import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { of } from 'rxjs/operators'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { User } from '../../shared/models/user';
import { EnvironmentLoaderService } from './environment-loader.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoggedUserDetailsService {
  // private userDetails = new BehaviorSubject('');
  loggedUserDetailsUrl: string = environment.loggedUserDetailsUrl;
  careerUrl = environment.careerUrl;
  recruterUrl = environment.recruiterdashboardUrl;
  validationUrl: string = environment.validationUrl;
  tncNewUrl: string = environment.tncNewUrl;
  private loggedUserDetails: BehaviorSubject<User> = new BehaviorSubject<User>(null);
  constructor(
    private http: HttpClient,
    private envData: EnvironmentLoaderService,
  ) {
    this.envData.getEnvData().then((envjson) => {
      this.loggedUserDetailsUrl = envjson['LoggedUserDetailsUrl'];
      this.careerUrl = envjson['CareerUrl'];
      this.recruterUrl = envjson['RecruiterdashboardUrl'];
      this.tncNewUrl = envjson['TnCNewUrl'];
      this.validationUrl = envjson['ValidationUrl'];
    });
  }
  // updateUserDetails(val: any) {
  //   this.userDetails.next(val);
  // }
  getUserDetails(): Observable<User> {
    return this.http.get<User>(this.loggedUserDetailsUrl + 'userlocation');
  }

  setLoggedUserDetails(userData) {
    this.loggedUserDetails.next(userData);
  }

  getLoggedUserDetails() {
    return this.loggedUserDetails.asObservable();
  }
  setLoggedUserUrl(loggedUserUrl) {
    this.loggedUserDetailsUrl = loggedUserUrl;
  }

  setCareersUserUrl(careersUrl) {
    this.careerUrl = careersUrl;
  }
  gettncDate(companyHiringTypeId, docName) {
    return this.http.get<any>(
      this.tncNewUrl + 'tnc/getTermsNConditions?compHiringTypeId=' + companyHiringTypeId + '&docName=' + docName,
    );
    //  return this.http.get<any>(this.careerUrl + "tnc/getTermsNConditions?compHiringTypeId="+companyHiringTypeId+"&docName="+docName);
    // return this.http.get<CandidateBasicDetails>(this.careersiteurl + "carrierSite/candidatedetails?compHiringTypeId="+companyHiringTypeId+"&docName="+docName);
    // return this.http.get<CandidateBasicDetails>("assets/json/candidateBasicDetails.json");
  }

  getUserTnc(body): Observable<any> {
    console.log(body);
    return this.http.post<any>(this.tncNewUrl + 'tnc/getUserTnc', body);
    // return this.http.post<any>(this.careerUrl + "tnc/getUserTnc", body);
  }

  saveUserTnc(body): Observable<any> {
    const headers = new HttpHeaders();
    const _options = { responseType: 'text', headers };
    const saveTncUrl = this.validationUrl.split('v1')[0];
    return this.http.post<any>(saveTncUrl + 'tnc/saveUserTnc', body);
    // return this.http.post<any>(this.careerUrl + "tnc/saveUserTnc",body);
  }

  getHMFlag(): Observable<any> {
    return this.http.get<any>(this.recruterUrl + 'getSysConfig?configKey=ENABLE_HIRING_MANAGER&comapanyHiringTypeId=4');
  }
}
